import '../../i18n';
import {useTranslation} from 'react-i18next';
import React, { useEffect } from 'react';

import Modal from './Modal';

import { GREEN, PRIMARY_COLOR } from '../../appearance/Colors';

import styled from 'styled-components';

function ConfirmModal({ title, description, closeButtonText, actionButtonText, isOpen, closeModal }) {
    const {t: lnT} = useTranslation();

    useEffect(() => {
        const handleKeyPress = event => {
            if (!isOpen) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                closeModal(false);
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isOpen, closeModal]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => closeModal(undefined)}
            style={confirmModalStyle}
            overlayClassName="Overlay"
            contentLabel={lnT('common:confirmation')}
        >
            <DialogContent>
                <DialogTitle>{title}</DialogTitle>
                <DialogDescription>{description}</DialogDescription>
                <DialogActions>
                    <ActionButton
                        onClick={event => {
                            event.stopPropagation();
                            closeModal(false);
                        }}
                    >
                        {closeButtonText || lnT('common:cancel')}
                    </ActionButton>
                    <ConfirmButton
                        onClick={event => {
                            event.stopPropagation();
                            closeModal(true);
                        }}
                    >
                        {actionButtonText || lnT('common:confirm')}
                    </ConfirmButton>
                </DialogActions>
            </DialogContent>
        </Modal>
    );
}

const confirmModalStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        color: 'black',
        maxWidth: 360,
        minWidth: 320,
        border: 'none',
        borderRadius: 18,
        padding: 18,
        backgroundColor: '#f7f7f7'
    }
};

const DialogContent = styled.div`
    display: flex;
    flex-direction: column;
`;

const DialogTitle = styled.div`
    color: ${PRIMARY_COLOR};
    font-weight: 600;
    font-size: 18px;
    line-height: 1.3;
    margin-bottom: 8px;
`;

const DialogDescription = styled.div`
    color: rgba(15, 15, 15, 0.72);
    margin-bottom: 18px;
    font-size: 14px;
    line-height: 1.5;
`;

const DialogActions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
`;

const ActionButton = styled.button`
    padding: 10px 14px;
    background-color: rgba(15, 15, 15, 0.08);
    border-radius: 12px;
    color: rgba(15, 15, 15, 0.82);
    font-size: 13px;
    cursor: pointer;
    font-weight: 600;
    border: none;
    user-select: none;
    &:hover {
        background-color: rgba(15, 15, 15, 0.12);
        color: rgba(15, 15, 15, 1);
    }
`;

const ConfirmButton = styled.button`
    padding: 10px 14px;
    background-color: ${GREEN};
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.92);
    font-size: 13px;
    cursor: pointer;
    font-weight: 600;
    border: none;
    user-select: none;
    &:hover {
        filter: brightness(0.92);
        color: rgba(255, 255, 255, 1);
    }
`;

export default ConfirmModal;
